export * from './lib/regex.factory';
export * from './lib/regex.provider';
